export const USER_MANAGEMENT_DOMAIN_PATH = "https://API.pgcloud.com/othersupportingdata/it/v1/as365UserManagement/"
export const WARRANTY_MANAGEMENT = "https://API.pgcloud.com/othersupportingdata/it/v1/as365Warranty/"
export const PRODUCT_AND_PARTS = "https://API.pgcloud.com/othersupportingdata/it/v1/as365pnp/"
export const DOAMIN_PATH = "https://API.pgcloud.com/othersupportingdata/it/v1/as365mdm/"
export const PRICING_DOMAIN_PATH = "https://API.pgcloud.com/othersupportingdata/it/v1/as365Pricing/"
export const LMS_DOMAIN_PATH = "https://API.pgcloud.com/othersupportingdata/it/v1/as365LMS/"
export const KNOWLEDGE_DOMAIN_PATH ="https://API.pgcloud.com/othersupportingdata/it/v1/as365Knowledge/"
export const SERVICE_CENTER_DOMAIN_PATH ="https://API.pgcloud.com/othersupportingdata/it/v1/as365ServiceNetwork/"
export const ORDER_MANAGEMENT ="https://API.pgcloud.com/othersupportingdata/it/v1/as365OrderManagement/"
export const DEVICE_REGISTRATION ="https://API.pgcloud.com/othersupportingdata/it/v1/as365device/"
export const WEB_URL = "https://aftersales365.pg.com/"
export const REPORTING_SERVICE_DOMAIN_PATH = "https://API.pgcloud.com/othersupportingdata/it/v1/as365Reporting"

export const UPLOAD_PATH = "https://API.pgcloud.com/othersupportingdata/it/v1/as365upload/"
export const NOTIFICATION_DOMAIN_PATH = "https://API.pgcloud.com/othersupportingdata/it/v1/as365notification/"

// Image Path

const IMG_URL = "https://image.aftersales365.pg.com/aftersales-container-01/"

export const TYPE_NO_IMAGE_URL = `${IMG_URL}type_number/`
export const PART_NO_IMAGE_URL = `${IMG_URL}part_number/`
export const HOT_SPOT_IMAGE_URL = `${IMG_URL}type_number/hotspot_images/`

export const SALES_ORG_IMAGE_URL = `${IMG_URL}sales_organization/`
export const SAMPLE_COLLECTION_IMAGE_URL = `${IMG_URL}sample_collection/`

export const environment = "prod"